import React from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18n';
import { I18nextProvider } from 'react-i18next';
import { ConfigProvider } from 'antd';
import { localizationConstants } from 'constants/index';
import { commonHelpers, localizationHelpers } from 'helpers';
import App from './App';
import { registerSW } from 'virtual:pwa-register';
import configHelpers from 'helpers/config';
const { parseJsonObject } = commonHelpers;

const { getClientConfig } = configHelpers;
const clientConfig = getClientConfig();

const swPushNotiRegistered = !!parseJsonObject(clientConfig?.extraConfig)
  ?.swPushNotiRegistered;

if ('serviceWorker' in navigator) {
  /**
   * `swPushNotiRegistered` and `swRegistered` are equivalent as far as the
   * service worker goes: both run the full flow (precache + runtime cache +
   * push notification). Registering the caching routes is what gives the SW a
   * fetch handler, and that is what keeps it alive for as long as a tab is
   * open — without one, Chrome stops the SW after ~30s of idle and the
   * in-memory notification state inside it is lost.
   */
  if (clientConfig.swRegistered || swPushNotiRegistered) {
    const onOk = registerSW();
    onOk(true);
  } else {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }
}

const { REGIONS } = localizationConstants;
const { getCurrentLanguage } = localizationHelpers;

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <ConfigProvider locale={REGIONS[getCurrentLanguage()].antdLocale}>
      <App />
    </ConfigProvider>
  </I18nextProvider>,
  document.getElementById('root')
);
